import LegalPage, { LegalSection } from '../components/LegalPage';
import { SITE } from '../lib/site';

const PoliticaPrivacidad = () => {
  return (
    <LegalPage title="Política de Privacidad" updated="Actualizado: agosto de 2026" url="/politica-de-privacidad">
      <LegalSection title="1. Responsable del tratamiento">
        <p>
          El responsable del tratamiento de los datos personales recogidos en este sitio
          web es {SITE.legalName} (en adelante, «HGO Servicios»), con domicilio en Málaga,
          España. Puede contactar con nosotros en {SITE.email} o en el teléfono {SITE.phoneDisplay}.
        </p>
      </LegalSection>
      <LegalSection title="2. Datos que recopilamos">
        <p>Tratamos únicamente los datos que nos facilitas voluntariamente a través de los formularios de la web o por contacto directo:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>Nombre y apellidos.</li>
          <li>Número de teléfono y correo electrónico.</li>
          <li>Información sobre tu proyecto (tipo de obra, ubicación aproximada, superficie, plazos).</li>
          <li>Datos técnicos de navegación anonimizados mediante cookies analíticas (con tu consentimiento).</li>
        </ul>
      </LegalSection>
      <LegalSection title="3. Finalidad y legitimación">
        <p>
          Tus datos se tratan con la finalidad de gestionar tu solicitud de presupuesto,
          contactar contigo para atender tu consulta y, si lo autorizas, enviarte
          información sobre nuestros servicios. La base legal es el consentimiento
          prestado al enviar el formulario y el interés legítimo en la gestión de la
          relación comercial. No cedemos tus datos a terceros, salvo obligación legal.
        </p>
      </LegalSection>
      <LegalSection title="4. Conservación">
        <p>
          Conservamos tus datos únicamente durante el tiempo necesario para gestionar tu
          solicitud y, en su caso, la relación contractual, o mientras exista una
          obligación legal de conservación. Puedes solicitar en cualquier momento su
          supresión.
        </p>
      </LegalSection>
      <LegalSection title="5. Tus derechos">
        <p>
          Puedes ejercer los derechos de acceso, rectificación, supresión, oposición,
          limitación del tratamiento y portabilidad escribiendo a {SITE.email}, indicando
          «Protección de datos» en el asunto. También puedes presentar una reclamación
          ante la Agencia Española de Protección de Datos (www.aepd.es).
        </p>
      </LegalSection>
      <LegalSection title="6. Cookies">
        <p>
          Este sitio utiliza cookies propias de sesión y, con tu consentimiento, cookies
          analíticas para medir el rendimiento de la página. Puedes aceptarlas o
          rechazarlas desde el aviso de cookies. En ningún caso utilizamos cookies de
          publicidad de terceros ni vendemos datos a anunciantes.
        </p>
      </LegalSection>
      <LegalSection title="7. WhatsApp y comunicación externa">
        <p>
          Al enviar tu solicitud de presupuesto mediante el formulario, se abre una
          conversación de WhatsApp con HGO Servicios. Los datos que compartas en esa
          conversación se rigen por la política de privacidad de WhatsApp (Meta
          Platforms) y se tratarán exclusivamente para atender tu consulta.
        </p>
      </LegalSection>
    </LegalPage>
  );
};

export default PoliticaPrivacidad;
